/**
 * Created with IntelliJ IDEA.
 * User: abahlk
 * Date: 12.07.13
 * Time: 10:42
 * To change this template use File | Settings | File Templates.
 */

import { ExternalLoggingConstants } from "../ExternalLoggingConstants";
import { AbstractLogObject } from "../logObjects/AbstractLogObject";
import { BasicLogObjectFactory } from "./BasicLogObjectFactory";

export class CookieErrorLOFactory extends BasicLogObjectFactory {
    public static GENERAL_ACCOUNT_COOKIE_ERROR: number = 4001;
    public static GENERAL_NETWORK_COOKIE_ERROR: number = 4002;

    private static COOKIE_ERROR: number = 4;

    constructor(subErrorId: number) {
        super();

        this._subErrorId = subErrorId;
    }

    public create(): AbstractLogObject {
        // Build the commonData
        let lo: AbstractLogObject = super.create();

        // Set custom data
        lo.logData.set(ExternalLoggingConstants.PARAM_LOG_EVENT_ID, CookieErrorLOFactory.COOKIE_ERROR.toString());

        return lo;
    }
}
